import TeacherInfo from './TeacherInfoContainer'
export default TeacherInfo